// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__9f4Hw","itemTitle":"ClientEmergencyInfo_itemTitle__3Ll3n","itemText":"ClientEmergencyInfo_itemText__1MQi_"};